import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import MainBanner from '../../components/MainBanner';
import AllBlogs from '../../components/AllBlogs';
import NewColumnWithForm from '../../components/NewColumnWithForm';
import NewFeaturedBlogs from '../../components/NewFeaturedBlogs';

export default function InsightsPage({
    global,
    all_news,
    featuredNews
}) {
    return (
        <>
            <SeoHead
                page_name={`Insights | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG`}
                canonical_link={`blog`}
            />
            <MainBanner
                global={global}
                pathPrefix={`insights_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Insights</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <NewFeaturedBlogs
                global={global}
                pathPrefix={`insights_page.new_featured_blogs`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Featured Blogs</h2>
                    </>
                }
                post={featuredNews}
                socialPagePrefix={`blog`}
            />
            <AllBlogs
                global={global}
                pathPrefix={`news_page.all_blogs`}
                customClass={`py-5 lightGreybg`}
                post={all_news}
                ParentNews={true}
                locale={``}
                heading={`All Blogs`}
            />
            <NewColumnWithForm
                global={global}
                pathPrefix={`insights_page.new_column_with_form`}
                customClass={`pb-5`}
                heading={`How can we help you?`}
                formId={`6c9ee93b-e8d3-43f8-b497-83ed2206fdc7`}
                description={
                    <>
                        <p>Contact us if you are interested in finding out more about how we can help you.</p>
                    </>
                }
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const news = (await Collection('news'))
        .filter(function (post) {
            return (
                post.country?.en == "United Kingdom" || post.country?.en == "All"
            );
        });

    const all_news = news.orderBy('date').getItems();

    const featuredNews = news
        .orderBy((news) => Date.parse(news.date?.en), 'desc')
        .getItems()
        .filter((item) => 
            item.tag.includes('Blog') && item.featured === true 
        );

    return {
        props: {
            global,
            all_news,
            featuredNews
        }
    };
}
